import { writable, derived } from 'svelte/store';
import type { ProfileAttrs, ProfileAttrsArray } from './profile.type';

// Create a custom writable store that prevents '{}' from being set as localbloom
function createProfileStore() {
	const { subscribe, set, update } = writable<ProfileAttrs>({
		username: '',
		realname: '',
		avatar_url: '',
		member: false,
		id: '',
		website: '',
		timezone: '',
		role: '',
		availability: 0.0,
		bio: '',
		persona: '',
		twitter: '',
		linkedin: '',
		github: '',
		communities: [],
		skills: [],
		profileredirects: 0,
		redirect: false,
		wallet: '',
		localbloom: '',
		localbloom_systemname: '',
		placename: '',
		needs: [],
		offers: [],
		member_app_in_progress: false,
		globalteam: false,
		website_url: '',
		average_rating: null,
		total_ratings: null
	});

	return {
		subscribe,
		set: (value: ProfileAttrs) => {
			// Prevent '{}' from being set as localbloom
			if (value.localbloom === '{}') {
				value.localbloom = '';
			}
			set(value);
		},
		update: (updater: (value: ProfileAttrs) => ProfileAttrs) => {
			update((value) => {
				const updated = updater(value);
				// Prevent '{}' from being set as localbloom
				if (updated.localbloom === '{}') {
					updated.localbloom = '';
				}
				return updated;
			});
		}
	};
}

export const profileStore = createProfileStore();

// Add loading state for profile
export const profileLoading = writable(false);

export const profileSchema: ProfileAttrs = {
	username: '',
	realname: '',
	avatar_url: '',
	member: false,
	id: '',
	website: '',
	timezone: '',
	role: '',
	availability: 0.0,
	bio: '',
	persona: '',
	twitter: '',
	linkedin: '',
	github: '',
	communities: [],
	skills: [],
	profileredirects: 0,
	redirect: false,
	localbloom: '',
	localbloom_systemname: '',
	placename: '',
	needs: [],
	offers: [],
	member_app_in_progress: false,
	globalteam: false,
	website_url: '',
	average_rating: null,
	total_ratings: null
};

export const memberStore = writable<ProfileAttrs>(profileSchema);
export const profiles = writable<ProfileAttrsArray>([profileSchema]);

export const shuffledProfilesStore = writable([]);
export const originalProfileOrder = writable([]);

// Function to update the avatar URL
export function updateAvatar(newAvatarUrl: string) {
	profileStore.update((profile) => {
		return { ...profile, avatar_url: newAvatarUrl }; // Update only the avatar_url
	});
}

export const avatarUrlStore = derived(profileStore, ($profileStore) => $profileStore.avatar_url);
